import React from 'react';
import Row from "@amzn/meridian/row";
import Box from "@amzn/meridian/box";
import Link from "@amzn/meridian/link";
import Tag from "@amzn/meridian/tag";
import Moment from "moment";

/**
 * This component will render filters for driver reconciliation screen
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const DriverReconciliationFilter = (props) => {
    const {filters} = props;

    return (<Row spacingInset="small large none large" alignment="bottom">
            <Box>
                <Link type="secondary" to="#" onClick={props.onToggle}>Options</Link>
            </Box>
            <Box className="option-filters">
                <Tag
                    key="date"
                    type="neutral"> {Moment(filters.date).local().format('MM/DD/YYYY')}</Tag>

                <Tag
                    key="driverName"
                    type="neutral"> {filters.driverName !== "" ? filters.driverName : "All Drivers"}
                </Tag>
            </Box>
        </Row>
    )
}

export default DriverReconciliationFilter;


// WEBPACK FOOTER //
// ./src/component/driverReconciliation/driverReconciliationFilter.js